import apiService from 'src/enviroment';

const projectionsService = {
  getIndustries: () => apiService.get('/proyeccion/maestros/industria/'),
  putIndistries: (params) => {
    const body = {
      valor: params.newData.valor,
      empresa: params.newData.empresa,
    };
    return apiService.put('/proyeccion/maestros/industria/', body);
  },
  getReleases: () => apiService.get('/proyeccion/maestros/lanzamientos/'),
  putReleases: (params) => {
    const body = {
      linea: params.newData.linea,
      valor: params.newData.meta,
    };
    return apiService.put('/proyeccion/maestros/lanzamientos/', body);
  },
};

export default projectionsService;
